import { MessageFeedback } from '@/Domain/api/Conversation/dto/Message.dto';

export type SimulationMessageDto = {
  id: number;
  ord_number: number;
  user_message: string;
  conversation_history: Record<string, unknown>[];
};

export type DatasetListDto = {
  id: number;
  name: string;
  description: string;
  message_count: number;
  run_count: number;
  latest_run_score: number | null;
  latest_run_manual_score: number | null;
  evaluation_criteria: string;
  created_timestamp: string;
  last_updated_timestamp: string;
};

export type DatasetDetailDto = DatasetListDto & {
  messages: SimulationMessageDto[];
  conversation_metadata: Record<string, unknown>;
};

export type RunListDto = {
  id: number;
  ord_number: number;
  label: string;
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
  total_messages: number;
  completed_messages: number;
  failed_messages: number;
  avg_eval_score: number | null;
  manual_avg_score: number | null;
  config_overrides: Record<string, unknown>;
  created_timestamp: string;
};

export type RunResultStatus = 'pending' | 'running' | 'evaluating' | 'completed' | 'failed';

export type RunResultDto = {
  id: number;
  simulation_message_id: number;
  user_message: string;
  ai_response: string | null;
  conversation_conv_id: string | null;
  ai_message_id: number | null;
  status: RunResultStatus;
  error_message: string;
  eval_score: number | null;
  eval_justification: string;
  improvement_hint: string | null;
  explanation_summary: string | null;
  feedback: MessageFeedback | null;
};

export type RunDetailDto = RunListDto & {
  results: RunResultDto[];
};

export type PaginatedResponse<T> = {
  items: T[];
  total: number;
  offset: number;
  limit: number;
};

export const DEFAULT_SIMULATION_PAGE_SIZE = 25;

export type RecentConversationVisitorMessageDto = {
  user_message: string;
  ord_number: number;
};

export type RecentConversationGroupDto = {
  conv_id: string;
  source: string;
  last_message_at: string;
  messages: RecentConversationVisitorMessageDto[];
  total_visitor_messages: number;
};

export type RecentVisitorMessagesResponseDto = {
  items: RecentConversationGroupDto[];
  has_real_conversations: boolean;
};

export type SelectedRecentMessage = {
  conv_id: string;
  ord_number: number;
  user_message: string;
};
